module.exports = __webpack_public_path__ + "img/clinic.817111c1.png";